module.exports = __webpack_public_path__ + "img/EDC5000AQ_1-1.b981b7c4.png";